module.exports = __webpack_public_path__ + "img/Japanese_population.704d942f.jpg";